import { render, staticRenderFns } from "./ListBankMovementsDetail.vue?vue&type=template&id=46a2430a"
import script from "./ListBankMovementsDetail.vue?vue&type=script&lang=js"
export * from "./ListBankMovementsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports